/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { IWizardChangeRoleTranslation } from '@modules/internationalization/types/wizards/changeRole';
import { EWizardChangeRoleSteps } from '@pages/WizardChangeRole/wizardChangeRoleConstant';

import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardChangeRoleTranslation: IWizardChangeRoleTranslation = {
    ...initWizardPropsTranslation,
    [EWizardChangeRoleSteps.StepSelectParams]: {
        levelPut: '',
        title: '',
    },
    [EWizardChangeRoleSteps.StepConfirmation]: {
        msisdn: '',
        recoveryToList: '',
        removedFromList: '',
    },
    validateErrors: {
        selectAccessLevel: '',
        selectOneSubscribers: '',
        fillNotify: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
    wizardSummary: {
        accessLevel: '',
        subsCount: '',
    },
};
